var _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRekordboxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.375,
    cy: 24.625,
    r: 24.375,
    fill: "#027DE1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1874_10634",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 30,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1953 21.9921C33.5157 22.9155 33.6908 23.8997 33.6908 24.9257C33.6908 29.3717 30.4735 33.0791 26.2125 33.9113V40.3586L37.6828 33.8404C38.4163 33.4237 38.8693 32.6523 38.8693 31.81V18.7635L33.1953 21.9921ZM17.4023 18.8737C18.2737 17.898 19.3464 17.1163 20.549 16.5807C21.7515 16.0452 23.0562 15.7681 24.3761 15.7678C27.1506 15.7678 29.6473 16.9762 31.3486 18.8737L37.0239 15.6462L25.5626 9.12679C25.1999 8.92213 24.789 8.81445 24.3709 8.81445C23.9528 8.81445 23.542 8.92213 23.1792 9.12679L11.7102 15.6462L17.383 18.8737H17.4023ZM15.0614 24.9257C15.0614 23.8997 15.2364 22.9155 15.5568 21.9921L9.88281 18.7622V31.7998C9.88281 32.632 10.3371 33.4135 11.0693 33.8303L22.5396 40.3484V33.9012C20.4294 33.4862 18.5307 32.3638 17.1671 30.7253C15.8034 29.0868 15.0593 27.0336 15.0614 24.9156V24.9257ZM29.0386 24.9244C29.0392 25.5273 28.9191 26.1244 28.685 26.6816C28.451 27.2387 28.1076 27.745 27.6745 28.1713C27.2415 28.5977 26.7272 28.9358 26.1612 29.1664C25.5952 29.3969 24.9886 29.5153 24.3761 29.5148C23.7636 29.5153 23.1571 29.3969 22.5912 29.1665C22.0253 28.936 21.5111 28.598 21.078 28.1718C20.645 27.7456 20.3016 27.2395 20.0674 26.6825C19.8333 26.1255 19.7131 25.5285 19.7136 24.9257C19.7131 24.3229 19.8333 23.726 20.0674 23.169C20.3016 22.612 20.645 22.1059 21.078 21.6796C21.5111 21.2534 22.0253 20.9154 22.5912 20.6849C23.1571 20.4545 23.7636 20.3361 24.3761 20.3366C24.9885 20.3361 25.595 20.4545 26.1609 20.6849C26.7268 20.9154 27.241 21.2534 27.6741 21.6796C28.1071 22.1059 28.4505 22.612 28.6847 23.169C28.9188 23.726 29.0391 24.3217 29.0386 24.9244Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1874_10634)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.1289,
    y: -17.5159,
    width: 67.0643,
    height: 58.3013,
    transform: "rotate(33 12.1289 -17.5159)",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRekordboxIcon);
export default __webpack_public_path__ + "static/media/rekordboxIcon.4d742012fbf60775c5b1cf841b14f649.svg";
export { ForwardRef as ReactComponent };